import request from '@/utils/request'
// 查询用户列表
export function userList (data) {
  return request({
    url: 'user/list',
    method: 'post',
    data
  })
}
// 查询用户树
export function userTree (data) {
  return request({
    url: 'user/tree',
    method: 'get',
    params: data
  })
}

// 用户详情
export function userDetail (id) {
  return request({
    url: 'user' + '/' + id,
    method: 'get'
  })
}

// 用户新增
export function addUser (data) {
  return request({
    url: 'user/add',
    method: 'post',
    data
  })
}
// 用户注册
export function registerUser (data) {
  return request({
    url: 'user/register',
    method: 'post',
    data
  })
}

// 用户修改
export function editUser (data) {
  return request({
    url: 'user/update',
    method: 'post',
    data
  })
}
// 修改密码
export function changePassword (data) {
  return request({
    url: '/user/updatePassword',
    method: 'post',
    data
  })
}
// 删除用户

export function deleteUser (data) {
  return request({
    url: 'user/delete',
    method: 'delete',
    params: data
  })
}

// 角色加载

export function loadRole (data) {
  return request({
    url: 'role/name',
    method: 'GET',
    params: data
  })
}
// 研究生加载

export function loadUser (data) {
  return request({
    url: 'user/name',
    method: 'GET',
    params: data
  })
}
// 律师修改头像
export function updatePhoto (data) {
  return request({
    url: 'lawyer/updatePhoto',
    method: 'POST',
    data
  })
}
// 获取绑定用户
export function bindRoleList (data) {
  return request({
    url: 'user/config/check',
    method: 'GET',
    params: data
  })
}
// 导师研究生列表
export function loadStudent (data) {
  return request({
    url: 'user/mentor/student',
    method: 'GET',
    params: data
  })
}

// 律师绑定研究生配置
export function userBindStudent (data) {
  return request({
    url: 'user/config/associate',
    method: 'POST',
    data
  })
}
// 获取已经绑定研究生
export function bindStudentList (data) {
  return request({
    url: 'user/associate/check',
    method: 'GET',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js